<script lang="ts" setup>
const client = useBoscaClient()

const props = defineProps<{
  item: any
  metadataId: string
  references: string[]
}>()

let usfms = ''
if (props.references && Array.isArray(props.references)) {
    for (const reference of props.references) {
        usfms += reference + '+'
    }
}

const { data: chapters } = useAsyncData(usfms, async (_) => {
    try {
        const chapters = []
        if (props.references && Array.isArray(props.references)) {
            for (const reference of props.references) {
                const chapter = await client.content.getBibleChapter(props.metadataId, reference)
                if (chapter) {
                    chapters.push(chapter)
                }
            }
        }
        return chapters
    } catch (e) {
        return []
    }
})

const current = ref(0)
</script>

<template>
  <div
    v-if="chapters && chapters.length > 0"
    class="flex flex-col pb-6 gap-4"
  >
    <h3 class="font-signifier text-center">
      Scripture References
    </h3>
    <div class="flex flex-wrap justify-center gap-4">
      <PButton
        v-for="(ref, index) in chapters"
        id="reference"
        :key="ref.usfm + '.' + index"
        :content="[{ id: item.id, type: item.__typename || [] }]"
        :extras="{ reference: ref.usfm }"
        :class="
          'no-underline font-sans '
            + (current === index ? 'text-blurple-600' : '')
        "
        :click="() => current = index"
      >
        {{ ref.reference.human }}
      </PButton>
    </div>
    <div class="flex w-full h-[400px] relative overflow-y-auto overflow-x-hidden border border-blurple-600 p-4 rounded-md">
      <div
        v-for="(chapter, index) in chapters"
        :key="chapter.usfm + '.' + index"
        :class="
          'flex flex-col w-full h-full pe-4 absolute transition-all '
            + (current === index
              ? 'bg-neutral-100 opacity-100'
              : 'opacity-0')
        "
      >
        <div class="bible reader">
          <ContentBibleComponent :component="chapter.component" />
        </div>
      </div>
    </div>
  </div>
</template>
